import React from 'react';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { IncludedSection } from './components/IncludedSection';
import { BonusSection } from './components/BonusSection';
import { ManualSection } from './components/ManualSection';
import { HowItWorks } from './components/HowItWorks';
import { TargetAudience } from './components/TargetAudience';
import { FAQSection } from './components/FAQSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <div className="min-h-screen w-full bg-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <StatsBar data-id="element-2" />
      <IncludedSection data-id="element-3" />
      <BonusSection data-id="element-4" />
      <ManualSection data-id="element-5" />
      <HowItWorks data-id="element-6" />
      <TargetAudience data-id="element-7" />
      <FAQSection data-id="element-8" />
      <TestimonialsSection data-id="element-9" />
      <PricingSection data-id="element-10" />
      <FinalCTA data-id="element-11" />
    </div>;
}